'use client'

import type { UseProductPriceDataFetcherProps } from '@maestro/commerce-blocks/hooks/hooks.types'

import { useMemo } from 'react'
import useSWR from 'swr'

import { getProductsPriceByIds } from '@maestro/commerce-blocks/client/api/products'

export const useProductPriceDataFetcher = (
  props: UseProductPriceDataFetcherProps
) => {
  const { productIds, baseProductId, cacheKeyContext } = props
  const swrKey = useMemo(() => {
    if (!productIds.length) {
      return null
    }
    return [
      'products-price',
      [...productIds].sort().join(','),
      baseProductId,
      cacheKeyContext,
    ]
  }, [baseProductId, cacheKeyContext, productIds])

  const { data, isLoading } = useSWR(
    swrKey,
    () => getProductsPriceByIds(productIds, baseProductId),
    {
      revalidateOnFocus: false,
    }
  )

  return {
    productsPriceMap: data,
    isLoading,
  }
}
